"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCreateQueryGroup = void 0;
const core_ui_1 = require("@sierralabs/core-ui");
function useCreateQueryGroup() {
    const { data, isLoading, error, post } = (0, core_ui_1.useApiPost)('query-groups');
    return {
        createdQueryGroup: data,
        isCreating: isLoading,
        error,
        createQueryGroup: post
    };
}
exports.useCreateQueryGroup = useCreateQueryGroup;
//# sourceMappingURL=useCreateQueryGroup.js.map